import React, { useRef } from 'react';
import { KlSheet } from '../modal/KlSheet';

export interface MobileContractDocumentsSheetProps {
    open: boolean;
    onClose: () => void;
    attachedDocuments: string[];
    onAddDocument: (fileName: string) => void;
    onRemoveDocument: (index: number) => void;
    isEditingAuthorized?: boolean;
}

export const MobileContractDocumentsSheet: React.FC<MobileContractDocumentsSheetProps> = ({
    open,
    onClose,
    attachedDocuments = [],
    onAddDocument,
    onRemoveDocument,
    isEditingAuthorized = false
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            onAddDocument(e.target.files[0].name);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    return (
        <KlSheet
            height="fixed"
            fixedHeight={372}
            open={open}
            onClose={onClose}
            title="Documentos del contrato"
            footer={
                <button
                    type="button"
                    onClick={onClose}
                    className="w-full h-11 rounded-[12px] font-bold text-sm bg-[#2563EB] hover:bg-blue-600 text-white shadow-md active:scale-[0.98] transition-transform"
                >
                    Guardar y cerrar
                </button>
            }
        >
            <div className="flex flex-col gap-3 -mx-1 py-1">
                {/* Lista de documentos adjuntos */}
                {attachedDocuments.length === 0 ? (
                    <div className="text-center text-[#64748B] dark:text-slate-400 text-[13px] italic py-4">
                        No hay documentos adjuntos.
                    </div>
                ) : (
                    <div className="space-y-2 max-h-40 overflow-y-auto">
                        {attachedDocuments.map((doc, idx) => (
                            <div
                                key={idx}
                                className="flex items-center justify-between p-2.5 bg-slate-50 dark:bg-slate-800/70 rounded-xl border border-slate-200 dark:border-slate-700"
                            >
                                <div className="flex items-center gap-2.5 overflow-hidden">
                                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                        <polyline points="14 2 14 8 20 8" />
                                    </svg>
                                    <span className="text-[13px] font-medium text-slate-800 dark:text-slate-200 truncate">
                                        {doc}
                                    </span>
                                </div>
                                {!isEditingAuthorized && (
                                    <button
                                        type="button"
                                        onClick={() => onRemoveDocument(idx)}
                                        aria-label="Eliminar documento"
                                        className="w-7 h-7 text-slate-400 hover:text-red-500 flex items-center justify-center shrink-0 active:scale-95"
                                    >
                                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Botón Adjuntar Archivo estilo 08 */}
                {!isEditingAuthorized && (
                    <div className="relative">
                        <input
                            ref={fileInputRef}
                            type="file"
                            onChange={handleFileChange}
                            className="absolute inset-0 opacity-0 cursor-pointer w-full h-full z-10"
                        />
                        <button
                            type="button"
                            className="w-full h-[60px] border-[1.5px] border-dashed border-[#93C5FD] dark:border-blue-800 rounded-[14px] bg-[#F5F9FF] dark:bg-blue-950/40 text-[#1D4ED8] dark:text-blue-300 text-[14px] font-bold flex items-center justify-center gap-2 active:scale-[0.99] transition-transform pointer-events-none"
                        >
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M8 12h8" />
                                <path d="M12 8v8" />
                            </svg>
                            <span>Adjuntar archivo</span>
                        </button>
                    </div>
                )}
            </div>
        </KlSheet>
    );
};
